import { SheetEntry } from "../../modules/s25-spreadsheet/types/sheet.js.types.expanded";
import { ReportBreakdown, ReportMeasureOption, ReportSeries, ReportSummaryCard } from "./report.types";

export const REPORT_EXPORT_COUNT_HEADER = "Count";
export const REPORT_EXPORT_SERIES_HEADER = "Series";

/** One sheet row per breakdown row; measures stay numeric so the sheet can be summed. */
export function breakdownToSheetRows(
    breakdown: ReportBreakdown | undefined,
    groupHeader: string,
    series: ReportSeries[],
    measures: ReportMeasureOption[],
): SheetEntry[] {
    const seriesLabelByKey = new Map(series.map((reportSeries) => [reportSeries.key, reportSeries.label]));
    return (breakdown?.rows ?? []).map((row) => {
        const sheetRow: SheetEntry = {
            [groupHeader]: row.label,
            [REPORT_EXPORT_SERIES_HEADER]: seriesLabelByKey.get(row.seriesKey) ?? row.seriesKey,
            [REPORT_EXPORT_COUNT_HEADER]: row.count,
        };
        for (const measure of measures) {
            sheetRow[measure.label] = row.measures?.[measure.key] ?? 0;
        }
        return sheetRow;
    });
}

export function cardsToSheetRows(cards: ReportSummaryCard[]): SheetEntry[] {
    return cards.map((card) => ({ Metric: card.label, Value: card.value }));
}

/** `Budget Reports` + `Plan Type` -> `Budget_Reports_Plan_Type.xlsx` */
export function reportExportFileName(dashboardTitle: string, widgetTitle: string): string {
    const safeName = `${dashboardTitle} ${widgetTitle}`.replace(/[^A-Za-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
    return `${safeName || "report"}.xlsx`;
}
